import React from "react";

export interface TaggedPermissionItem {
  id: number;
  label: string;
  tag: string;
}

interface TaggedPermissionListProps {
  items: TaggedPermissionItem[];
}

const TaggedPermissionList: React.FC<TaggedPermissionListProps> = ({
  items,
}) => (
  <ul className="text-sm text-slate-600 dark:text-slate-300 space-y-1">
    {items.map((item) => (
      <li className="flex items-center gap-2" key={item.id}>
        <span className="w-1.5 h-1.5 rounded-full bg-slate-400 dark:bg-slate-500" />
        {item.label}
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {item.tag}
        </span>
      </li>
    ))}
  </ul>
);

export default TaggedPermissionList;
